import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LocationsService } from "../../services/locations/locations.service";
import { EmailService } from "../../services/email/email.service";
import { ActivatedRoute, Router } from "@angular/router";
import { IMyDpOptions } from "mydatepicker";

@Component({
  selector: "app-reservation-form",
  templateUrl: "./reservation-form.component.html",
  styleUrls: ["./reservation-form.component.scss"]
})
export class ReservationFormComponent implements OnInit {
  public reservationForm: FormGroup;
  public reservationSuccess = false;
  public formType = "";
  public locations;
  public formSubmitting = false;
  public showErrorMessage = false;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "mm.dd.yyyy"
  };

  private placeholder = "Event Date";

  public model: any = { date: { year: 2018, month: 10, day: 9 } };

  constructor(private _fb: FormBuilder, private _activeRoute: ActivatedRoute, private _locationsService: LocationsService, private _router: Router, private _emailService: EmailService) {
    this.reservationForm = _fb.group({
      name: ["", Validators.required],
      email: ["", Validators.pattern("[^ @]*@[^ @]*")],
      date: [null, Validators.required],
      phone: "",
      location: ["", Validators.required],
      additionalComments: ""
    });
  }

  ngOnInit() {
    this._activeRoute.params.subscribe(params => {
      this.formType = params.formType;
    });
    this._locationsService.getLocations().subscribe(locations => {
      this.locations = locations["locations"];
      console.log("locations", this.locations);
    });
  }

  setDate(): void {
    // Set today date using the patchValue function
    const date = new Date();
    this.reservationForm.patchValue({
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    });
  }

  clearDate(): void {
    // Clear the date using the patchValue function
    this.reservationForm.patchValue({ myDate: null });
  }

  submitForm() {
    console.log(this.reservationForm);

    if (!this.reservationForm.invalid) {
      this.formSubmitting = true;
      console.log(this.reservationForm);
      const formObject = {
        reservation: this.capatalizeFirstLetter(this.formType) + " Reservation",
        name: this.reservationForm.controls.name.value,
        email: this.reservationForm.controls.email.value,
        date: this.reservationForm.controls.date.value.date,
        phone: this.reservationForm.controls.phone.value,
        location: this.reservationForm.controls.location.value,
        additionalComments: this.reservationForm.controls.additionalComments.value
      };

      this._emailService
        .sendReservationFormData(formObject)
        .then(result => {
          console.log("success", result);
          this.reservationSuccess = true;
          this.formSubmitting = false;
        })
        .catch(error => {
          console.log(error, "did not send");
        });
    } else {
      this.showErrorMessage = true;
    }
  }

  closeReservationSuccess() {}

  closeForm() {
    this._router.navigate(["event-reservations"]);
  }

  private capatalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/event-reservations/reservation-form/reservation-form.component.ts